import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { motion } from 'framer-motion';
import { Space, Tabs } from 'antd';

import PageTabs from '../PageTabs';
import { useWindowSize } from '@/hooks';
import { AuthoritiesType } from '@/types/Authority';
import AccessDenied from '../AccessDenied';
import { hasComboPermissions } from '@/utils/functions/hasComboPermissions';
import AccessUpgrade from '../AccessUpgrade';
import { hasPermissions } from '@/utils/functions/hasPermissions';

interface TabContentWrapperProps {
  children: ReactNode;
  title: string;
  extra?: ReactNode;
  permissions?: AuthoritiesType[];
  isQRCode?: boolean;
}

function TabContentWrapper({
  children,
  title,
  extra,
  permissions,
  isQRCode,
}: TabContentWrapperProps) {
  const intl = useIntl();
  const { isMobile } = useWindowSize();

  const hasCombo = hasComboPermissions(permissions);

  return (
    <>
      <PageTabs tabBarExtraContent={extra}>
        <Tabs.TabPane
          key="item"
          tab={
            permissions && hasPermissions(permissions) ? (
              intl.formatMessage({ id: title })
            ) : (
              <Space>{intl.formatMessage({ id: title })}</Space>
            )
          }
        />
      </PageTabs>
      {extra && isMobile && <div className="tab-wrapper-actions">{extra}</div>}
      <div
        className="tab-wrapper"
        style={isQRCode ? { padding: '2.5rem 1rem 3.25rem' } : {}}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {permissions && !hasPermissions(permissions) ? (
            <>
              {hasCombo && <AccessDenied />}

              {!hasCombo && <AccessUpgrade />}
            </>
          ) : (
            children
          )}
        </motion.div>
      </div>
    </>
  );
}

export default TabContentWrapper;
